import { ShopfloorLayoutSpecNode } from './shopfloor-layout-spec-node'
import { GroupedEdgeTarget } from './grouped-edge-target'

export class GroupedEdge {
  constructor(
    public source: ShopfloorLayoutSpecNode,
    public targets: GroupedEdgeTarget[]
  ) {}
}
